import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const roblox = defineConnector({
  identifier: "roblox",
  name: "Roblox",
  tagLine: "Creator resources and player profiles",
  logo,
  tags: ["data"],
  protocol: "http",
  defaultUrlPattern: () =>
    "https://apis\\.roblox\\.com/(?:oauth/v1/userinfo|cloud/.*)$",
  auth: oauthAuth,
  steps: oauthSetupSteps({
    identifier: "roblox",
    registrationUrl: "https://create.roblox.com/dashboard/credentials",
    scopes: ["openid", "profile"],
  }),
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://apis.roblox.com/oauth/v1/authorize",
    tokenEndpoint: () => "https://apis.roblox.com/oauth/v1/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["openid", "profile"],
    pkce: () => true,
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://apis.roblox.com/oauth/v1/userinfo",
  },
});
